export default __webpack_public_path__ + "static/media/glitch08.59c43d7a.png";